import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sectionsActions from '../../redux/actions/sectionsActions';

import DownloadItem from '../features/splash/DownloadItem';

function DownloadPage({ status, sections, dispatchSectionsActions }) {
  if (!status.sections) {
    // Calling this here so that it fires again if we log out and lose the sections we had
    dispatchSectionsActions.getSections();
  }

  return (
    <Fragment>
      <Helmet>
        <title>Download</title>
      </Helmet>
      <div className="page-header">
        <div className="row">
          <h1 className="page-header__heading">Downloading the Print Tracer Tool</h1>
          <div className="text page-header__text">
            <p>
              Downloaded and printed tracer tool modules, once completed, can be scanned, uploaded and archived for reference. Modules completed as a print version cannot be directly compared to digital versions within the digital&nbsp;interface.
            </p>
          </div>
        </div>
      </div>
      <div className="section-selector row">
        <div className="section-selector__list">
          <DownloadItem
            section={{
              theme: 'rta-med-safety',
              fullTitle: 'All Tracers',
              pdf: '/documents/RTA_MedSafety_TracerTool.pdf',
              description: 'Includes module tracers for Patient Safety and Regulatory Compliance, Pharmacy, Nursing Units, and Anesthesia.',
            }}
          />
          {Object.entries(sections).map(([id, section]) => (
            <DownloadItem
              key={id}
              section={section}
            />
          ))}
        </div>
        <div className="section-selector__sidebar">
          <Link to="/assessments/new" className="button button--full-width button--large">
            Online Assessment
          </Link>
          <p>
            In order to make it easier, we’ve integrated a comparison functionality into the digital tool, as well as automated reminders and controls for tracking and managing user contribution.
          </p>
          <p>
            We recommend using the digital version of the tool. It’s completely free, easy to use, and entirely confidential. Create an account to get started.
          </p>
          <Link
            to="/resources"
            className="button button--full-width button--large"
          >
            Resources
          </Link>
          <p>
            Access documents to help analyze drug wastage, or create a plan for corrective&nbsp;actions.
          </p>
        </div>
      </div>
    </Fragment>
  );
}

function mapStateToProps(state) {
  return {
    sections: state.sections,
    status: state.status,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatchSectionsActions: bindActionCreators(sectionsActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DownloadPage);



// WEBPACK FOOTER //
// ./src/components/pages/DownloadPage.js